import React from 'react';
import { Layers, BarChart3, Zap } from 'lucide-react';
export function FeaturesSection() {
  return <section className="w-full bg-[#FAF9F7] pt-24 pb-32 px-4" data-id="element-6">
      <div className="max-w-5xl mx-auto" data-id="element-7">
        {/* Header Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-24 items-start mb-20" data-id="element-8">
          <h2 className="text-3xl md:text-[2.75rem] font-medium tracking-tight text-[#0F0F0F] leading-[1.1]" data-id="element-9">
            Made for modern marketing teams
          </h2>{' '}
          <p className="text-lg md:text-xl text-[#5C5C5C] leading-relaxed pt-1" data-id="element-10">
            Andoe helps marketing teams understand and improve how their
            business appears across AI models like ChatGPT and Google AI
            Overview.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-11">
          {/* Feature 1 */}
          <div className="group p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] hover:border-[#D0CEC9] shadow-[0_2px_8px_rgba(0,0,0,0.02)] transition-colors duration-300" data-id="element-12">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-13">
              <Layers className="w-6 h-6 text-[#1A1A1A]" data-id="element-14" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-15">
              Categorize custom prompts to gain clarity
            </h3>
          </div>

          {/* Feature 2 */}
          <div className="group p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] hover:border-[#D0CEC9] shadow-[0_2px_8px_rgba(0,0,0,0.02)] transition-colors duration-300" data-id="element-16">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-17">
              <BarChart3 className="w-6 h-6 text-[#1A1A1A]" data-id="element-18" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-19">
              Visualize your AI search visibility and position
            </h3>
          </div>

          {/* Feature 3 */}
          <div className="group p-8 rounded-2xl bg-[#FDFCFB] border border-[#E8E6E3] hover:border-[#D0CEC9] shadow-[0_2px_8px_rgba(0,0,0,0.02)] transition-colors duration-300" data-id="element-20">
            <div className="mb-6 inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#FAF9F7] border border-[#E8E6E3]" data-id="element-21">
              <Zap className="w-6 h-6 text-[#1A1A1A]" data-id="element-22" />
            </div>
            <h3 className="text-xl font-medium text-[#0F0F0F] tracking-tight" data-id="element-23">
              Analyze and identify opportunities
            </h3>
          </div>
        </div>
      </div>
    </section>;
}